import { RootState } from '../store'

const getBeanoState = (state: RootState) => state.beano
const getActiveForm = (state: RootState) => state.beano.activeForm

export const BeanoSelectors = {
  activeForm: getActiveForm,
  state: getBeanoState
}
